import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "rounded-lg p-5 flex flex-col gap-y-3 shadow-md border border-gray-200 cursor-pointer" }
const _hoisted_2 = { class: "text-base leading-6 font-medium text-gray-900" }
const _hoisted_3 = { class: "text-sm leading-5 font-normal text-gray-500" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("b", null, "Example: ", -1)

interface Props {
    title: string
    example: string
}

export default /*#__PURE__*/_defineComponent({
  __name: 'TriggerCard',
  props: {
    title: {},
    example: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.title), 1),
    _createElementVNode("p", _hoisted_3, [
      _hoisted_4,
      _createTextVNode(_toDisplayString(_ctx.example), 1)
    ])
  ]))
}
}

})